<template>
  <div class="pt-3 page-container">
    <section>
      <v-row no-gutters>
        <v-col cols="12">
          <v-radio-group v-model="cddType" row class="ma-0">
            <v-radio v-for="cdd in cddTypes" :key="cdd.text" :label="cdd.text" :value="cdd.value">
            </v-radio>
          </v-radio-group>
        </v-col>
      </v-row>

      <v-row no-gutters>
        <v-col cols="12" v-if="me">
          <keep-alive>
            <component
              :key="`${me.userId}_${selectedComponent}`"
              :is="selectedComponent"
              @success="success"
            ></component>
          </keep-alive>
        </v-col>
      </v-row>
    </section>
    <!-- <v-btn @click="success">테스트</v-btn> -->
  </div>
</template>
<script>
import ResidentCard from '@/components/kyc/id-cards/ResidentCard.vue'
import DriverLicense from '@/components/kyc/id-cards/DriverLicense.vue'
import { mapGetters, mapState, mapActions } from 'vuex'
import { redirectSignupManage } from '@/util/signupManage'

export default {
  components: {
    ResidentCard,
    DriverLicense,
  },
  data() {
    return {
      isValid: false,
      cddTypes: [
        {
          text: '주민등록증',
          value: 'residentCard',
          component: 'ResidentCard',
        },
        {
          text: '운전면허증',
          value: 'driverLicense',
          component: 'DriverLicense',
        },
      ],
      cddType: 'residentCard',
      selectedComponent: null,
       nextPath: '',
    }
  },
  computed: {
    ...mapState('auth', ['me']),
    ...mapGetters('auth', ['referralCode']),
  },
  watch: {
    isValid: {
      immediate: true,
      handler(v) {
        if (v === true) {
          this.nextStep()
        }
      },
    },
    cddType: {
      immediate: true,
      handler(v) {
        const selected = this.cddTypes.filter((cdd) => {
          return cdd.value === v
        })
        this.selectedComponent = selected[0].component
      },
    },
  },
  created() {
    _meta({
      titles: ['신분증제출'],
    })

    this.nextPath = this.$route.query.next || '/'
    console.log('****** 신분증 페이지. nextPath = ', this.nextPath)
  },
  methods: {
    ...mapActions('auth', ['getMe']),
    nextStep() {
      if (this.isValid === false) {
        return
      }
      this.$emit('next-step')
    },
    async success() {
      const type = this.cddTypes.find((e) => e.value === this.cddType)
      await this.$swal.basic.alert({
        html: `${type?.text} 인증이<br/>완료되었습니다.`,
      })
      if (await redirectSignupManage()) {
        return
      }

      await this.getMe()
      console.log('****** THIS.GETME() ')
      if( this.nextPath !== '' ) {
          return await this.$router.push(this.nextPath)
        } else {
          return await this.$router.push('/signup/bank/withdrawal')
        }
    },
  },
}
</script>

<style lang="scss" scoped>
.v-input {
  &:deep(.v-input--radio-group__input) {
    display: flex;
    justify-content: space-around;
  }
}
</style>
